<div class="row pad-top-10" [formGroup]="riskGroup">
  <h4>{{ risk.description }}</h4>
  @if (risk.previouslyEnrolled) {
    <div class="column twelve md-eight lg-ten paddedInput">
      <fieldset class="radio">
        <span class="inline-block pad-top-10">
          <input
            type="radio"
            formControlName="newDeviceInput"
            [id]="risk.id + '-new-device-false'"
            [value]="false"
            (change)="newDeviceChanged()"
          />
          <label [for]="risk.id + '-new-device-false'">
            I still have my device from a previous enrollment of this vehicle.
          </label>
        </span>
        <span class="inline-block pad-top-10">
          <input
            type="radio"
            formControlName="newDeviceInput"
            [id]="risk.id + '-new-device-true'"
            [value]="true"
            (change)="newDeviceChanged()"
          />
          <label [for]="risk.id + '-new-device-true'"> I need a new device shipped to me. </label>
        </span>
      </fieldset>
    </div>
  }
  <div class="column twelve md-eight lg-ten paddedInput" [hidden]="!displayShipToAddress">
    <ds-form-control-container labelText="Ship To Address" [control]="shipToInput">
      <select class="icon fill" formControlName="shipTo" (change)="shipToChanged()">
        <option value="" selected disabled></option>
        @for (shipTo of shipTos; track shipTo; let i = $index) {
          <option [value]="i">{{ shipTo | address }}</option>
        }
        <option value="newShipTo">Add New Address</option></select
      ><span class="icon-chevron-down"></span>
      <ds-form-control-message [control]="shipToInput"></ds-form-control-message>
    </ds-form-control-container>
  </div>
  <app-kyd-new-address
    [hidden]="!displayShipToAddress || !displayNewAddress"
    [riskGroup]="riskGroup"
    [risk]="risk"
    [shipTos]="shipTos"
    (customAddress)="handleCustomAddress($event)"
  >
  </app-kyd-new-address>
</div>
